import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'zsd-itemdetailcontainer',
    templateUrl: '../view/serviceitemsdetailcontainer.component.html',
    styleUrls: ['../view/serviceitemsdetailcontainer.component.scss'
    ],
    encapsulation: ViewEncapsulation.None
})

export class ServiceItemsDetailContainerComponent  {
    constructor() {
    }
}
